<template>
<div class=""  style="padding:0 20px;">

<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Centro</el-breadcrumb-item>
         <el-breadcrumb-item>Profilo</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>

  <el-form ref="formBasic" :model="itmform" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

  <div class="title_h1 yo-color-primary" style="margin-bottom:30px;" v-if="$centro.profile.rowIsNew">RICHIESTA DI ADESIONE</div>



  <!--
    Il sottoscritto, CHIEDE per conto del proprio centro di essere ammesso ......
  -->


<!--
<div class="title_h1 yo-color-primary" style="margin-top:30px;">QUOTA DI ISCRIZIONE:</div>

<ul>
<li>Euro 70.00 Socio Medico</li>
<li>Euro 35.00 Socio Medico under 35</li>
<li>Euro 30.00 Socio Infermiere</li>
</ul>

-->



   <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI ENTE</div>
   <div class="row " style="margin-top:20px;">



      <div class="col s12">
      <el-form-item label="Struttura (Ricerca: Cod. Min., Comune o Regione)" prop="codiceministeriale" >
        <el-select v-model="$centro.profile.row.codiceministeriale"  placeholder="Selezionare dalla lista" style="width:100%;" clearable filterable v-on:change="setCodiceministeriale">
          <el-option v-for="item in $teras._struttura" :key="item.id" :label="item.id+' - '+item.nome+' - '+item.regione+' - '+item.citta" :value="item.id" >
            <span style="float: left;text-transform:uppercase;">{{ item.nome }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12" style="padding-bottom:24px;">
        In caso di struttura non presente nell'elenco, si prega di scrivere a <a href="mailto:d.turoli@neonatalnet.org">d.turoli@neonatalnet.org</a> indicando il codice ministeriale della struttura
      </div>

<!--
      <div class="col s12">
      <el-form-item label="Denominazione" prop="nome">
        <el-input  v-model="$centro.profile.row.nome" disabled></el-input>
      </el-form-item>
      </div> 
-->
<!--
      <div class="col s12">
      <el-form-item label="Tipologia struttura" prop="tipologia">
        <el-input  v-model="$centro.profile.row.tipologia" disabled></el-input>
      </el-form-item>
      </div> 
-->

      <div class="col s12">
      <el-form-item label="Livello" prop="livello">
        <el-select v-model="$centro.profile.row.livello"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="La struttura dispone di reparto di patologia neonatale" value="I livello" ></el-option>
          <el-option label="La struttura dispone di reparto di patologia e terapia intensiva neonatale" value="II Livello" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Indirizzo" prop="address">
        <el-input  v-model="$centro.profile.row.address"></el-input>
      </el-form-item>
      </div>


      <div class="col s12">
      <el-form-item label="Partecipa al Network VON" prop="isvon">
        <el-select v-model="$centro.profile.row.isvon"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="No" :value="0"></el-option>
          <el-option label="Si" :value="1"></el-option>
        </el-select>
      </el-form-item>
      </div> 
<!--
      <div class="col s12">
      <el-form-item label="Tipologia struttura" prop="tipologia">
        <el-select v-model="$centro.profile.row.tipologia"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Ospedale a Gestione Diretta ASL" value="Ospedale a Gestione Diretta ASL"></el-option>
          <el-option label="Azienda Ospedaliera" value="Azienda Ospedaliera"></el-option>
          <el-option label="Azienda Ospedaliera Universitaria Integrata" value="Azienda Ospedaliera Universitaria Integrata"></el-option>
          <el-option label="Policlinico Universitario Privato" value="Policlinico Universitario Privato"></el-option>
          <el-option label="Istituto a Carattere Scientifico Pubblico" value="Istituto a Carattere Scientifico Pubblico"></el-option>
          <el-option label="Istituto a Carattere Scientifico Privato" value="Istituto a Carattere Scientifico Privato"></el-option>
          <el-option label="Ospedale Classificato" value="Ospedale Classificato"></el-option>
          <el-option label="Casa di Cura Accreditata" value="Casa di Cura Accreditata"></el-option>
          <el-option label="Casa di Cura non Accreditata" value="Casa di Cura non Accreditata"></el-option>
        </el-select>
      </el-form-item>
      </div> 
-->
<!--
      <div class="col s12 m6">
      <el-form-item label="Unità Operativa" prop="uo">
        <el-input  v-model="$centro.profile.row.uo"></el-input>
      </el-form-item>
      </div> 
-->

<!--
      <div class="col s12 m6">
      <el-form-item label="CAP" prop="cap">
        <el-input  v-model="$centro.profile.row.cap"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Provincia" prop="provincia">
        <el-select v-model="$centro.profile.row.provincia"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.id" :label="item.nome" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12">
      <el-form-item label="Città" prop="citta">
        <el-input v-model="$centro.profile.row.citta"></el-input>
      </el-form-item>
      </div> 
-->
   </div>  


<!--

   <div class="title_h1 yo-color-primary" style="margin-top:30px;">DIRETTORE UO</div>
   <div class="row pad" style="margin-top:20px;">
          
      <div class="col s12 m6">
      <el-form-item label="Cognome" prop="dircognome">
        <el-input  v-model="$centro.profile.row.dircognome" v-on:change="setRefisdir"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nome" prop="dirnome">
        <el-input  v-model="$centro.profile.row.dirnome" v-on:change="setRefisdir"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Email" prop="diremail">
        <el-input  v-model="$centro.profile.row.diremail" v-on:change="setRefisdir"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Cellulare" prop="dircellulare">
        <el-input  v-model="$centro.profile.row.dircellulare" v-on:change="setRefisdir"></el-input>
      </el-form-item>
      </div> 
   
   </div>

-->

<div  v-if="$centro.profile.rowIsNew">
   <div class="title_h1 yo-color-primary" style="margin-top:30px;">REFERENTE INNSIN</div>
   <div class="row" style="margin-top:20px;">
<!--
      <div class="col s12 m6">
      <el-form-item label="È il direttore della UO?" prop="refisdir">
        <el-select v-model="$centro.profile.row.refisdir"  placeholder="Selezionare dalla lista" style="width:100%;" v-on:change="setRefisdir" >
          <el-option label="No" :value="0" ></el-option>
          <el-option label="Si" :value="1" ></el-option>
        </el-select>
      </el-form-item>
      </div> 
-->
  
      <div class="col s12 m6" >
      <el-form-item label="Cognome" prop="refcognome">
        <el-input  v-model="$centro.referente.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6" >
      <el-form-item label="Nome" prop="refnome">
        <el-input  v-model="$centro.referente.row.nome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6" >
      <el-form-item label="Email" prop="refemail">
        <el-input  v-model="$centro.referente.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinserisci Email" prop="emailcheck"  class="is-required">
        <el-input  v-model="emailcheck"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 " >
      <el-form-item label="Cellulare" prop="refcellulare">
        <el-input  v-model="$centro.referente.row.cellulare"></el-input>
      </el-form-item>
      </div> 
   
   
   
   </div>
   </div>












    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Annulla</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" v-if="$centro.profile.rowIsNew">Registrati</el-button>
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" v-else>Salva</el-button>
      </div>
    </div>


    </el-form>
<!-- 
<el-button type="primary" @click="emailFirst" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Email</el-button>
-->
</div>
</template>

<script>
import emailRegister from './Email-register.vue'
export default {
  name: 'centro-profile',
  components: {

  },
  data() {
    return {
      itm: this.$centro.profile.row, //mi serve per far si che funzioni correttamente il binding
      itmref: this.$centro.referente.row, //mi serve per far si che funzioni correttamente il binding
      emailcheck:'',
      authcheck: this.$moment().format('YYYY-MM-DD'),
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$centro.profile.email) {
          return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
        }else{
          callback();
        }
      },
      checkVon: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value<0) {
          return callback(new Error('Bisogno indicare se il centro aderisce al VON'));
        }else{
          callback();
        }
      }
    }
  },
  created () {
    console.log("Arrivo al centro-profile.vue con id "+this.$centro.profile.row.id)
    if(typeof this.$centro.profile.row.id == 'undefined')
      this.isNew()
    //this.$teras.pageTitle = (this.$centro.profile.row.id=='') ? 'Nuova Attività' : 'Modifica Attività: '+this.$centro.profile.row.id
  },
  beforeDestroy () {

  },
  methods: {
    isNew: function(){
      this.$centro.profile.new().then((response) =>  {
        this.$centro.profile.row.password = this.$teras.random()
        this.$centro.profile.row.step = 0
        this.$centro.profile.row.refisdir = 0
        this.$centro.referente.new()
      })
    },
    setCodiceministeriale: function(){
      console.log("CIPROVO con id "+this.$centro.profile.row.codiceministeriale)
      if(this.$centro.profile.row.codiceministeriale>0){
        let row = this.$teras.rowbyvalue(this.$centro.profile.row.codiceministeriale,this.$teras._struttura,'id')
        console.log(row)
        this.$centro.profile.row.nome = row.nome
        this.$centro.profile.row.tipologia = row.tipo
      }else{
        this.$centro.profile.row.nome = ''
        this.$centro.profile.row.tipologia = ''
      }  
    }
    ,setRefisdir: function(){
      /*
      if(this.$centro.profile.row.refisdir==1){
        this.$centro.referente.row.cognome = this.$centro.profile.row.dircognome
        this.$centro.referente.row.nome = this.$centro.profile.row.dirnome
        this.$centro.referente.row.email = this.$centro.profile.row.diremail
        this.$centro.referente.row.cellulare = this.$centro.profile.row.dircellulare
      }*/
      
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/login/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {

          let error = -1

          if(this.$centro.profile.rowIsNew){
            if(this.$centro.referente.row.email != this.emailcheck)
              error = 100
            
            console.log("CONTROLLO EMAIL PER ID "+this.$centro.referente.row.id)
            console.log(this.$centro.referente.row)
            let checkEmail = await this.$centro.checkEmail(this.$centro.referente.row.email,this.$centro.referente.row.id)
            if(checkEmail==false)
              error = 101
            
          }
          
          let checkMinisteriale = await this.$centro.checkMinisteriale(this.$centro.profile.row.codiceministeriale,this.$centro.profile.row.id)
          if(checkMinisteriale==false)
            error = 102

          switch (error){
            case -1:
            this.Save()
            break;

            case 100:
            this.$notify.error({title: 'Errore '+error,message: 'L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'})
            break;

            case 101:
            this.$notify.error({title: 'Errore '+error,message: 'Lei sembra già essere tra i nostri contatti o ha già provato ad iscriversi, la preghiamo di contattare la segreteria!'})
            break;

            case 102:
            this.$notify.error({title: 'Errore '+error,message: 'Il codice ministeriale inserito è già presente tra quelli aderenti al network, la preghiamo di contattare la segreteria!'})
            break;

            default:
            this.$notify.error({title: 'Errore non specificato',message: 'Siamo spiacenti si è verificato un errore, la preghiamo di contattare la segreteria!'})
          }


          
    
        } else {
          this.$notify.error({title: 'Errore',message: 'Non tutti i campi sono stati compilati correttamente!'})
          return false;
        }
      });
    },
    async Save(){

      //this.$centro.profile.row.dircognome = this.$centro.profile.row.dircognome.toUpperCase()
      //this.$centro.profile.row.dirnome = this.$centro.profile.row.dirnome.toUpperCase()
      this.$centro.profile.row.inseritoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
      if(this.$centro.profile.row.step<1)
        this.$centro.profile.row.step = 1
      
      await this.$centro.profile.save() //.then(data => async {       



      if(this.$centro.profile.row.step==1){
        this.$centro.referente.row.cognome = this.$centro.referente.row.cognome.toUpperCase()
        this.$centro.referente.row.nome = this.$centro.referente.row.nome.toUpperCase()
        this.$centro.referente.row.centro = this.$centro.profile.row.id
        this.$centro.referente.row.ruolo = 10
        await this.$centro.referente.save()
        this.$teras.utente = this.$centro.referente.row
        this.$storage.save("utente",this.$centro.referente.row)
        this.emailFirst()
        this.$centro.profile.row.step = 2
        this.$centro.profile.save()
        this.$router.push('/centro-documenti/')
      }else{
        this.$router.push('/home/')
      }
      
      
    }
    ,emailFirst(){
      var html = this.$teras.renderVue(emailRegister,{contatto:this.$teras.utente})
      this.$axios.email({from:'innsin@terasmm.it',oggetto:'Ricezione richiesta di adesione al progetto INNSIN',to:this.$teras.utente.email,body:html}).then((data) => {
        console.log("Email con registrazione del centro inviata")
      }).catch((error) => {
        console.log("Errore nell'invio della email con la registrazione del centro")
        console.log(error)
      })
      this.$axios.email({from:'innsin@terasmm.it',oggetto:'Ricezione richiesta di adesione al progetto INNSIN',to:'d.turoli@neonatalnet.org,mirko@terasmm.it',body:html}).then((data) => {
        console.log("Email con registrazione del centro inviata")
      }).catch((error) => {
        console.log("Errore nell'invio della email con la registrazione del centro")
        console.log(error)
      })
    }

  },
  computed: {
    itmform:function() {
      return this.$teras.objmerge(this.$centro.profile.row,{
        refcognome:this.$centro.referente.row.cognome
        ,refnome:this.$centro.referente.row.nome
        ,refemail:this.$centro.referente.row.email
        ,refcellulare:this.$centro.referente.row.cellulare
        })
    },
    rules:function() {
      var rulesNow = {
        nome: [
          { required: true, message: 'Il nome del centro è obbligatorio', trigger: 'blur' }
        ],
        
        /*
        dircognome: [
          { required: true, message: 'Il cognome del direttore è obbligatorio', trigger: 'blur'  }
        ],
        dirnome: [
          { required: true, message: 'Il nome del direttore è obbligatorio', trigger: 'blur' }
        ],
        dircellulare: [
          { required: true, message: 'Il cellulare del direttore è obbligatorio'}
        ],
        emailchecks: [
          { required: true, message: 'L\'indirizzo email di controllo è obbligatorio'}
        ],     
        diremail: [
          { required: true, message: 'L\'indirizzo email del direttore è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email del direttore corretto', trigger: 'blur,change' }
        ],
        */
        codiceministeriale: [
          { required: true, message: 'Il codice ministeriale è obbligatorio', trigger: 'blur' }
        ],
        /*
        tipologia: [
          { required: true, message: 'La tipologia è obbligatoria', trigger: 'blur' }
        ],
        */
        /*
        uo: [
          { required: true, message: 'L\'unità operativa è obbligatoria', trigger: 'blur' }
        ],
        */
        livello: [
          { required: true, message: 'Il livello è obbligatorio', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'L\'indirizzo è obbligatorio', trigger: 'blur' }
        ],
        isvon:[
          { required: true, message: 'Bisogna indicare se si partecipa al VON'},
          { validator: this.checkVon, trigger: 'blur' }
        ],
        cap: [
          { required: true, message: 'Il CAP è obbligatorio', trigger: 'blur' }
        ],
        citta: [
          { required: true, message: 'La città è obbligatoria', trigger: 'blur' }
        ],
        provincia: [
          { required: true, message: 'La provincia è obbligatoria', trigger: 'blur' }
        ],
        refcognome: [
          { required: true, message: 'Il cognome del referente è obbligatorio', trigger: 'blur'  }
        ],
        refnome: [
          { required: true, message: 'Il nome del referente è obbligatorio', trigger: 'blur' }
        ],
        refcellulare: [
          { required: true, message: 'Il cellulare del referente è obbligatorio'}
        ],
        refemail: [
          { required: true, message: 'L\'indirizzo email del referente è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email del referente corretto', trigger: 'blur,change' }
        ]


        
        
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;



}
</style>